import React from "react";
import styled from "styled-components";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Event from "../components/mainEvent/Event";
import HeaderSvg from "../components/HeaderSvg";

const MainEvent = () => {
  return (
    <AppWrapper>
      <HeaderSvg />
      <Header />
      <Event />
      <Footer />
    </AppWrapper>
  );
};

const AppWrapper = styled.div``;

export default MainEvent;
